module.exports = __webpack_public_path__ + "img/foggy.569c779d.svg";